import React from "react";
import "../css/AboutUs.css"; //  Ensure you have the appropriate CSS file

const Features = () => {
  return (
    <div className="about-us">
      <h2>Features</h2>
      <h3>Client Data Collection</h3>
      <p>
        Forms and tools designed to collect comprehensive data from clients easily. Customizable templates based on different advisor profiles (Insurance, Mutual Funds, Certified Financial Planners).
      </p>
      <h3>Data Processing and Financial Horoscope Generation</h3>
      <p>
        A system that processes the collected data and generates a “Financial Horoscope” (Personalized Financial Report/Plan). Visual representation of financial health, investment recommendations, etc.
      </p>
      <h3>Conversion Rate Optimization</h3>
      <p>
        Tools to help advisors track their interactions with clients and improve their conversion rate. Automated follow-up reminders, lead tracking, and nurturing suggestions.
      </p>
      <h3>Increased Ticket Size</h3>
      <p>
        Insights that allow financial professionals to suggest higher-value products or investment options. Upsell and cross-sell recommendations based on client profiles.
      </p>
      <h3>Integration with Other Tools</h3>
      <p>
        Ability to integrate with other financial tools like CRM systems or financial planning software.
      </p>
    </div>
  );
};

export default Features;